export abstract class AppColors {

// Primary Brand Colors
  static readonly primarySoftBlue = '#2C5BB9';
  static readonly primarySoftBlueTint = '#378FEF';
  static readonly primarySoftBlueShade = '#1C74D3';

  static readonly primaryLazyGreen = '#1AAA69';
  static readonly primaryLazyGreenTint = '#5ADB97';
  static readonly primaryLazyGreenShade = '#22D175';

  static readonly primaryMustardYellow = '#CBC343';
  static readonly primaryMustardYellowTint = '#EFE856';
  static readonly primaryMustardYellowShade = '#D3C909';

  static readonly primaryLightGray = '#CBCBCB';
  static readonly primaryLightGrayTint = '#DADADA';
  static readonly primaryLightGrayShade = '#ACACAC';

  static readonly primaryPureBlack = '#000000';
  static readonly primaryPureBlackTint = '#393935';
  static readonly primaryPureBlackShade = '#000000';

// Secondary Brand Colors
  static readonly secondaryLazyBlue = '#09126D';
  static readonly secondaryBrightBlue = '#2F3AE4';
  static readonly secondaryLightBlue = '#3EC8F7';
  static readonly secondarySlowYellow = '#FFC208';
  static readonly secondaryDullOrange = '#FF9F41';
  static readonly secondaryBurntOrange = '#FF6643';

}
